import { useContext } from "react";
import { ChatContext } from "./ChatContext";
import { useAiConciergeChatSuggestionsQuery, useChatSuggestionsQuery } from "../generated/ai-client";
import { Suggestion } from "./Suggestion";
import { useTheme } from "@equiem/react-end-user-ui";

// Same build flag as ChatContext: AI Concierge picks questions its site's content can answer.
const askAiConcierge = process.env.aiConciergeChatEnabled === "true";

export const ChatWindowSuggestions = () => {
  const { chatStarted } = useContext(ChatContext);
  const aiApi = useChatSuggestionsQuery({ skip: askAiConcierge });
  const concierge = useAiConciergeChatSuggestionsQuery({ skip: !askAiConcierge });
  const { spacers } = useTheme();

  const suggestions = askAiConcierge
    ? (concierge.data?.aiConciergeChatSuggestions ?? [])
    : (aiApi.data?.aiChatSuggestions ?? []);

  return (
    <>
      {!chatStarted && suggestions.length > 0 && (
        <div className="suggestions">
          {suggestions.map((suggestion) => (
            <Suggestion key={suggestion.uuid} suggestion={suggestion} />
          ))}
        </div>
      )}
      <style jsx>{`
        .suggestions {
          display: flex;
          flex-wrap: nowrap;
          overflow: auto;
          padding: ${spacers.s3} ${spacers.s4};
        }
      `}</style>
    </>
  );
};
